import officeAbsenceModule, { Approver } from '@/store/modules/OfficeAbsenceModule';
import { hubClient } from '@tfpl/api-client';

export const setPrimaryAbsenceApprover = (user: hubClient.MinimalCollaboratorDto) => {
  const approver: Approver = {
    fullName: `${user.firstName} ${user.lastName}`,
    avatarUrl: user.slackAvatarUrl,
    id: user.id,
    uuid: user.uuid,
    priority: true,
  };

  officeAbsenceModule.clearApprovers();
  officeAbsenceModule.addApprover(approver);
};
